import { Color, Theme } from '@opallabs/gem'

/**
 * Resources in the database can either be undefined or an old grey default.
 * In both cases, we'd rather throw it out and use the default Gem Text color.
 */
const isValidColor = (color: string | null | undefined): color is string => {
  return typeof color === 'string' && !/(6f7d8a|6f7d89)/i.test(color)
}

export const useResourceColor = (theme: Theme, colorStr?: string | null) => {
  return isValidColor(colorStr) ? `#${colorStr}` : Color[theme].Text.Default
}
